
import Vue from 'vue';
import { ITagOption, ITag } from '../store/state';
import { search } from '../store/actions';

interface ISearchDropdownProps {
  options: ITagOption[],
  filterTitle: string,
  filterName: string,
  isTag: boolean,
}

interface ISearchDropdownMethods {
  onSelectFilter(filterName: string, filterTitle: string, option: ITagOption): void;
  getSelectedOptions(options: ITagOption[]): ITagOption[];
  updateSelectedFilters(setFilter: string, selectedOptions: ITagOption[]): void;
}

export default Vue.extend<{}, ISearchDropdownMethods ,{} ,ISearchDropdownProps>({
	name: 'SearchDropdown',
	props: {
		options: [],
    filterTitle: String,
    filterName: String,
    isTag: Boolean,
	},

  methods: {
    getSelectedOptions(options: ITagOption[]) {
      return options.filter((option: ITagOption) => option.selected);
    },

    updateSelectedFilters(setFilter: string, selectedOptions: ITagOption[]) {
      this.$store.commit({
        type: setFilter,
        payload: selectedOptions
          .map((option: ITagOption) => option.name)
          .join(","),
      });
    },

    onSelectFilter(filterName: string, filterTitle: string, option: ITagOption) {
      if(option) {
        this.$store.commit({
          type: 'setSelectedFilters',
          payload: {
            name: filterName,
            title: filterTitle,
            option
          }
        });
      }

      this.$store.dispatch(search(""));
    }
  },
})
